import KLineEntity from '@/utils/klineEntity'
import KLineDataHelper from '@/utils/klineDataHelper'
import { parseInterval } from '@/utils'

import { Big } from 'big.js'

const contract = {
  namespaced: true,
  state: {
    interval: '15m', // 获取历史数据时需调用utils下的getResolution方法转换
    contractData: {
      coin: 'BTC',
      contractNo: 'BTC_USDT',
    }, // 当前交易对数据
    controlCoin: 0, // 排序：名称
    controlPrice: 0, // 排序：价格
    controlUpDown: 0, // 排序：涨幅
    currentSkin: 'black', // 皮肤（所有的皮肤类型为：black、white）（默认：black暗色）
    // 盘口买入和卖出第一个价格和改变后的价格
    handicapFirstPrice: {
      unassigned: true,
      buyFirstPrice: '',
      sellFirstPrice: '',
    },
    shimHandicap: 'buySell', // 当前选择的盘口（默认：买卖盘）
    klineData: [], // K线
    plateData: {}, // 盘口
    indicator: ['MA', 'VOL'],

    quotes: [], // 实时行情
  },
  mutations: {
    SET_CONTRACT_DATA(state, contract) {
      state.contractData = contract
    },
    SET_PLATE_DATA(state, value) {
      state.plateData = value
    },
    /** 清空K线数据 */
    CLEAR_KLINE_DATA(state) {
      state.klineData = []
    },
    /** 设置K线数据 */
    SET_KLINE_DATA(state, { data, symbol, type, isAll }) {
      const { type: _type } = parseInterval(state.interval, 500, true)
      if (
        symbol.toUpperCase() === state.contractData.contractNo &&
        type === _type
      ) {
        if (isAll) {
          const tempArr = data.map((item) => {
            const [time, open, close, max, min, volume] = item
            return new KLineEntity({ time, open, close, max, min, volume }, 1)
          })
          KLineDataHelper.calculate(tempArr)
          state.klineData = tempArr
        } else {
          const tempArr = [...state.klineData]
          tempArr.pop()
          const [time, open, close, max, min, volume] = data
          tempArr.push(
            new KLineEntity({ time, open, close, max, min, volume }, 1)
          )
          KLineDataHelper.calculate(tempArr)
          state.klineData = tempArr
        }
      }
    },
    SET_QUOTE_DATA(state, quote) {
      quote.change = Big(quote.change).times(100).toString()
      if (quote.contractNo === state.contractData.contractNo) {
        state.contractData = quote
      }
      const { quotes } = state
      const idx = quotes.findIndex(
        (item) => item.contractNo === quote.contractNo
      )
      if (idx === -1) {
        quotes.push(quote)
      } else {
        quotes.splice(idx, 1, quote)
      }
    },
    /** 设置指标 */
    SET_INDICATOR(state, value) {
      state.indicator = value
    },
    /** 设置k线类型 */
    SET_INTERVAL(state, interval) {
      state.interval = interval
    },
    SET_HANDICAP_FIRST_PRICE(state, priceObj) {
      state.handicapFirstPrice = priceObj
    },
    SET_CURRENT_HANDICAP(state, handicap) {
      state.shimHandicap = handicap
    },
    SET_CONTROL_COIN(state, coin) {
      state.controlCoin = coin
    },
    SET_CONTROL_PRICE(state, price) {
      state.controlPrice = price
    },
    SET_CONTROL_UPDOWN(state, updown) {
      state.controlUpDown = updown
    },
  },
}

export default contract
